import { render, staticRenderFns } from "./settings-device-activity.vue?vue&type=template&id=350ae0a6&"
import script from "./settings-device-activity.vue?vue&type=script&lang=js&"
export * from "./settings-device-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports